var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.56 127.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#004c8a;}.cls-3{fill:none;stroke:#004c8a;stroke-linejoin:round;stroke-width:1.28px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.22,73.3c0-4.23,4.95-4.98,4.95-6.63,0-.8-.64-1.14-1.23-1.14-1.09,0-1.7,1.22-1.7,1.22l-2.08-1.39s1.06-2.46,4.03-2.46c1.87,0,3.91,1.07,3.91,3.51,0,3.57-4.61,4.26-4.69,5.73h4.87v2.4h-7.92c-.08-.45-.13-.85-.13-1.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.13,66.51c.4-.78.74-1.04.74-1.04v-.03s-.16.05-.74.05h-4.51v-2.4h8.21v1.95l-4.8,9.49h-2.91l4.02-8.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.88,69.25c0-3.1,1.9-6.35,5.46-6.35,1.6,0,2.53.5,2.53.5l-.75,2.4s-.75-.34-1.57-.34c-1.34,0-2.11.83-2.46,1.89h.03c.27-.19,1.02-.4,1.57-.4,2.39,0,3.75,1.95,3.75,3.92s-1.42,3.86-3.91,3.86c-2.3,0-4.64-1.74-4.64-5.47ZM58.67,70.88c0-.82-.5-1.68-1.73-1.68-.64,0-1.18.16-1.18.69,0,1.36.96,2.27,1.76,2.27.7,0,1.15-.61,1.15-1.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.34,71.87h2.64l-1.81,4.43h-2.03l1.2-4.43Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.6,71.06s1.04,1.02,2.32,1.02c.75,0,1.6-.46,1.6-1.41s-.78-1.42-1.82-1.42c-.88,0-1.54.38-1.54.38l-1.49-.56.46-5.99h6.4v2.4h-3.97l-.06,1.06c0,.22-.06.45-.06.45h.03s.4-.11.83-.11c2.72,0,4.1,1.7,4.1,3.76,0,2.37-1.74,4.08-4.24,4.08s-3.91-1.5-3.91-1.5l1.34-2.16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.6,63.08h3.04l1.66,4.83c.26.74.58,1.89.58,1.89h.03s.32-1.15.58-1.89l1.66-4.83h3.04l.93,11.44h-2.8l-.35-5.15c-.06-.86,0-1.92,0-1.92h-.03s-.38,1.2-.64,1.92l-1.2,3.31h-2.4l-1.2-3.31c-.26-.72-.64-1.92-.64-1.92h-.03s.06,1.06,0,1.92l-.35,5.15h-2.82l.94-11.44Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.57,84.28h.68v3.02c0,.79.12,1.49,1.09,1.49,1.15,0,1.86-1.01,1.86-2.1v-2.41h.68v5.03h-.66v-.75c0-.22.02-.4.02-.4h-.02c-.2.49-.86,1.27-1.97,1.27-1.18,0-1.68-.64-1.68-1.95v-3.2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.52,84.28h.67v.75c0,.22-.02.4-.02.4h.02c.18-.46.82-1.27,2.01-1.27s1.68.71,1.68,1.95v3.2h-.68v-3.02c0-.79-.12-1.49-1.09-1.49-.86,0-1.6.59-1.83,1.42-.06.21-.08.44-.08.68v2.41h-.68v-5.03Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.43,82.28h.71v.85h-.71v-.85ZM41.45,84.28h.68v5.03h-.68v-5.03Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.96,84.91h-.66v-.57h.67v-1.45h.67v1.45h1.26v.57h-1.26v2.5c0,1.18.75,1.33,1.13,1.33.14,0,.23-.02.23-.02v.61s-.11.02-.29.02c-.58,0-1.75-.19-1.75-1.87v-2.57Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.08,88.2s.56.61,1.5.61c.54,0,1.01-.27,1.01-.8,0-1.1-2.71-.83-2.71-2.47,0-.9.81-1.39,1.72-1.39,1.06,0,1.55.55,1.55.55l-.31.52s-.43-.46-1.26-.46c-.51,0-1,.22-1,.78,0,1.11,2.71.81,2.71,2.47,0,.82-.71,1.41-1.72,1.41-1.22,0-1.86-.73-1.86-.73l.37-.49Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.24,84.28h.65v.49c0,.22-.02.39-.02.39h.02s.41-1,1.74-1,2.19,1.08,2.19,2.64-.95,2.63-2.25,2.63c-1.21,0-1.65-.96-1.65-.96h-.02s.02.18.02.44v2.4h-.68v-7.03ZM56.5,88.82c.89,0,1.62-.75,1.62-2.03s-.65-2.02-1.59-2.02c-.84,0-1.63.6-1.63,2.03,0,1.01.56,2.02,1.6,2.02Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.08,82.28h.68v5.69c0,.66.3.76.56.76.09,0,.17-.01.17-.01v.61s-.12.02-.25.02c-.42,0-1.16-.13-1.16-1.23v-5.84Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.27,86.19h.28v-.13c0-.97-.53-1.3-1.25-1.3-.83,0-1.42.48-1.42.48l-.32-.52s.66-.57,1.79-.57c1.21,0,1.88.67,1.88,1.93v3.22h-.65v-.55c0-.25.02-.42.02-.42h-.02s-.42,1.09-1.68,1.09c-.84,0-1.71-.49-1.71-1.49,0-1.7,2.21-1.74,3.08-1.74ZM64.01,88.84c.96,0,1.54-1,1.54-1.87v-.22h-.29c-.79,0-2.37.03-2.37,1.14,0,.47.37.95,1.12.95Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.09,84.16c1.23,0,1.84.72,1.84.72l-.35.51s-.56-.61-1.47-.61c-1.1,0-1.96.82-1.96,2.02s.87,2.02,1.98,2.02c1.02,0,1.61-.71,1.61-.71l.31.53s-.68.79-1.96.79c-1.49,0-2.64-1.07-2.64-2.63s1.16-2.64,2.64-2.64Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.42,84.16c1.39,0,2.1,1.07,2.1,2.32,0,.12-.02.35-.02.35h-3.86c.03,1.29.91,1.99,1.95,1.99.92,0,1.53-.61,1.53-.61l.31.52s-.73.7-1.86.7c-1.5,0-2.63-1.08-2.63-2.63,0-1.65,1.12-2.64,2.48-2.64ZM76.83,86.26c-.04-1.05-.68-1.54-1.43-1.54-.84,0-1.57.53-1.73,1.54h3.16Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.75,84.16c1.22,0,1.64.95,1.64.95h.02s-.02-.17-.02-.38v-2.45h.68v7.03h-.66v-.53c0-.22.02-.36.02-.36h-.02s-.41,1.01-1.73,1.01-2.19-1.08-2.19-2.64.94-2.63,2.26-2.63ZM80.78,88.81c.84,0,1.63-.6,1.63-2.03,0-1.02-.52-2.02-1.6-2.02-.89,0-1.62.75-1.62,2.02s.65,2.03,1.59,2.03Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.69,84.16c1.47,0,2.66,1.12,2.66,2.61s-1.19,2.66-2.66,2.66-2.66-1.14-2.66-2.66,1.19-2.61,2.66-2.61ZM89.69,88.81c1.08,0,1.96-.88,1.96-2.05s-.88-1.99-1.96-1.99-1.96.85-1.96,1.99.88,2.05,1.96,2.05Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.62,84.28h.67v.75c0,.22-.02.4-.02.4h.02c.18-.46.82-1.27,2.01-1.27s1.68.71,1.68,1.95v3.2h-.68v-3.02c0-.79-.12-1.49-1.09-1.49-.86,0-1.6.59-1.83,1.42-.06.21-.08.44-.08.68v2.41h-.68v-5.03Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.73,96.91h-.66v-.57h.67v-1.45h.67v1.45h1.26v.57h-1.26v2.5c0,1.18.75,1.33,1.13,1.33.14,0,.23-.02.23-.02v.61s-.11.02-.29.02c-.58,0-1.75-.19-1.75-1.87v-2.57Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.89,94.28h.68v2.72c0,.23-.02.41-.02.41h.02c.19-.48.86-1.25,2-1.25,1.24,0,1.68.71,1.68,1.95v3.2h-.68v-3.02c0-.79-.12-1.49-1.09-1.49-.86,0-1.6.59-1.83,1.43-.06.2-.08.43-.08.67v2.41h-.68v-7.03Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.95,96.16c1.39,0,2.1,1.07,2.1,2.32,0,.12-.02.35-.02.35h-3.86c.03,1.29.91,1.99,1.95,1.99.92,0,1.53-.61,1.53-.61l.31.52s-.73.7-1.86.7c-1.5,0-2.63-1.08-2.63-2.63,0-1.65,1.12-2.64,2.48-2.64ZM34.36,98.26c-.04-1.05-.68-1.54-1.43-1.54-.84,0-1.57.53-1.73,1.54h3.16Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.04,96.28h.67v.75c0,.22-.02.4-.02.4h.02c.24-.68,1.04-1.27,1.82-1.27.93,0,1.41.43,1.56,1.26h.02c.27-.68,1-1.26,1.85-1.26,1.22,0,1.67.71,1.67,1.95v3.2h-.68v-3.03c0-.82-.17-1.5-1.09-1.5-.77,0-1.4.68-1.59,1.42-.07.22-.09.46-.09.73v2.38h-.68v-3.03c0-.76-.11-1.5-1.06-1.5-.82,0-1.44.71-1.65,1.48-.05.21-.07.44-.07.67v2.38h-.68v-5.03Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.87,98.19h.28v-.13c0-.97-.53-1.3-1.25-1.3-.83,0-1.42.48-1.42.48l-.32-.52s.66-.57,1.79-.57c1.21,0,1.88.67,1.88,1.93v3.22h-.65v-.55c0-.25.02-.42.02-.42h-.02s-.42,1.09-1.68,1.09c-.84,0-1.71-.49-1.71-1.49,0-1.7,2.21-1.74,3.08-1.74ZM49.61,100.84c.96,0,1.54-1,1.54-1.87v-.22h-.29c-.79,0-2.37.03-2.37,1.14,0,.47.37.95,1.12.95Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.4,96.28h.67v.89c0,.22-.02.4-.02.4h.02c.24-.76.8-1.34,1.59-1.34.14,0,.27.03.27.03v.67s-.12-.02-.25-.02c-.71,0-1.24.56-1.46,1.3-.1.32-.14.66-.14.98v2.12h-.68v-5.03Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.96,94.28h.68v3.92h.8l1.51-1.92h.82l-1.75,2.19v.02l1.92,2.82h-.81l-1.68-2.52h-.81v2.52h-.68v-7.03Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.11,96.16c1.39,0,2.1,1.07,2.1,2.32,0,.12-.02.35-.02.35h-3.86c.03,1.29.91,1.99,1.95,1.99.92,0,1.53-.61,1.53-.61l.31.52s-.73.7-1.86.7c-1.5,0-2.63-1.08-2.63-2.63,0-1.65,1.12-2.64,2.48-2.64ZM65.52,98.26c-.04-1.05-.68-1.54-1.43-1.54-.84,0-1.57.53-1.73,1.54h3.16Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.7,96.91h-.66v-.57h.67v-1.45h.67v1.45h1.26v.57h-1.26v2.5c0,1.18.75,1.33,1.13,1.33.14,0,.23-.02.23-.02v.61s-.11.02-.29.02c-.58,0-1.75-.19-1.75-1.87v-2.57Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.53,94.28h.71v.85h-.71v-.85ZM73.55,96.28h.68v5.03h-.68v-5.03Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.87,96.28h.67v.75c0,.22-.02.4-.02.4h.02c.18-.46.82-1.27,2.01-1.27s1.68.71,1.68,1.95v3.2h-.68v-3.02c0-.79-.12-1.49-1.09-1.49-.86,0-1.6.59-1.83,1.42-.06.21-.08.44-.08.68v2.41h-.68v-5.03Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.27,100.85c0-2.47,3.6-2.79,3.6-4.69,0-.77-.58-1.35-1.46-1.35-1.03,0-1.57.96-1.57.96l-.52-.35s.64-1.27,2.13-1.27c1.34,0,2.14.87,2.14,1.97,0,2.36-3.55,2.69-3.56,4.56h3.67v.62h-4.39c-.03-.16-.04-.31-.04-.45Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.02,97.78c0-2.02.6-3.63,2.43-3.63s2.42,1.61,2.42,3.63-.59,3.64-2.42,3.64-2.43-1.6-2.43-3.64ZM94.15,97.78c0-1.67-.37-2.98-1.7-2.98s-1.71,1.31-1.71,2.98.37,2.99,1.71,2.99,1.7-1.31,1.7-2.99Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.17,100.85c0-2.47,3.6-2.79,3.6-4.69,0-.77-.58-1.35-1.46-1.35-1.03,0-1.57.96-1.57.96l-.52-.35s.64-1.27,2.13-1.27c1.34,0,2.14.87,2.14,1.97,0,2.36-3.55,2.69-3.56,4.56h3.67v.62h-4.39c-.03-.16-.04-.31-.04-.45Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.09,99.93s.72.83,1.8.83c.84,0,1.61-.62,1.61-1.52,0-.99-.85-1.5-1.77-1.5h-.48l-.17-.41,1.76-2.06c.19-.22.37-.39.37-.39v-.02s-.2.03-.57.03h-2.64v-.62h4.11v.46l-2.1,2.42c.89.05,2.2.55,2.2,2.07,0,1.2-.98,2.2-2.31,2.2s-2.23-.96-2.23-.96l.42-.53Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.53,24.48h21.81v26.94h-21.81v-26.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.53,32.18h21.81"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 55.44,
    cy: 41.8,
    r: 7.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.1,27.05h8.98v2.57h-8.98v-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.65,27.05h5.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.65,29.61h5.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.95,42.44l.83-.83c.29-.29.69-.46,1.1-.46.41,0,.81.16,1.1.46l.37.37c.29.29.69.46,1.1.46.41,0,.81-.16,1.1-.46l.37-.37c.29-.29.69-.46,1.1-.46.41,0,.81.16,1.1.46l.83.83"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 55.44,
    cy: 41.8,
    r: 4.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.82,16.78h15.4v7.7h-15.4v-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.08,16.78v7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.65,18.71v1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.65,21.28v1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.74,21.92l2.57-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.59,21.92l2.57-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.18,48.86v2.57h2.57v-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.78,24.48v-11.55h19.25v35.92h-16.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.34,27.05h16.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.89,30.9h2.57v7.7h-2.57v-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.78,15.5h19.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepair1);
export default __webpack_public_path__ + "static/media/repair1.3a9bb1e42224424b0a609a935ab19e7e.svg";
export { ForwardRef as ReactComponent };